<template>
  <div :class="{ 'dark-mode': isSupplierOne }">
    <LazyDiscoverResellerCategoryOnlyCategories
      :category-list="categories.filter((category) => category.title)"
      :dark-mode="isSupplierOne"
    />
    <div class="container mt-10 category-only">
      <template v-if="activeCategory">
        <h1>
          <div class="md:text-heading-2 text-mobile-heading-2 text-primary-1">
            {{ t("discover.exploreTheBest") }}
          </div>
          <div
            class="rtl:hidden md:text-heading-2 text-mobile-heading-2 text-primary-2"
          >
            {{ activeCategory.title }} {{ t("experiences") }}
          </div>
        </h1>
        <p
          class="ltr:hidden md:text-heading-2 text-mobile-heading-2 text-primary-2"
        >
          <template v-if="locale !== 'ar'">
            {{ t("experiences") }}
          </template>
          {{ activeCategory.title }}
        </p>
      </template>
      <template v-else>
        <p class="md:text-heading-2 text-mobile-heading-2 text-primary-1">
          {{ t("discover.allTheBest") }}
        </p>
        <p class="md:text-heading-2 text-mobile-heading-2 text-primary-2">
          {{ t("discover.toursActivitiesWorldwide") }}
        </p>
      </template>
    </div>
    <LazyDiscoverActivities
      class="md:!pt-[50px] pt-5 container mb-16"
      :facets="discoverFacets"
      :dark-mode="isSupplierOne"
      is-general
    />
  </div>
</template>

<script lang="ts" setup>
import { useAsyncData } from "nuxt/app";
import { useRoute } from "vue-router";

const route = useRoute();
const { t } = useI18n();
const locale = useCookie("locale");

const { data: discoverFacets } = await useAsyncData<any>("facets", () =>
  customFetch(`api/v2/products/facets`)
);
const runtimeConfig = useRuntimeConfig();
const layout = runtimeConfig.public.layout;
const isSupplierOne = ref(false);
isSupplierOne.value = layout.type?.includes("supplier-one") ?? false;

const categories = discoverFacets.value.categories;

const activeCategory = categories.find(
  (category) => category.slug == route.params.categorySlug
);
const site = useSiteConfig();

useSeoMeta({
  ogTitle: `${activeCategory ? `${activeCategory.title} | ` : ""} ${site.name}`,
  ogDescription: activeCategory
    ? `${t("discover.exploreTheBest")} ${activeCategory.title} ${t("experiences")}`
    : `${t("discover.allTheBest")} ${t("discover.toursActivitiesWorldwide")}`,
  description: activeCategory
    ? `${t("discover.exploreTheBest")} ${activeCategory.title} ${t("experiences")}`
    : `${t("discover.allTheBest")} ${t("discover.toursActivitiesWorldwide")}`,
  ogUrl: site.url.replace(/\/+$/, "") + route.fullPath,
});
</script>
<style lang="scss">
.dark-mode {
  .category-tag {
    @apply bg-white;
    &.is-active {
      @apply bg-primary-2;
    }
  }
  .category-only {
    p,
    h1 div {
      @apply text-title-color;
    }
  }
}
</style>
